import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { initAppHeaderForPreviewRoute } from './common/header/appHeaderVisibility';
import { msalConfig } from './authConfig';
import App from './App';
import env from './common/env';
import * as serviceWorker from './serviceWorker';
import newrelic from './modules/newrelic/newrelic';

initAppHeaderForPreviewRoute();

const container = document.getElementById('root');
const root = createRoot(container);

const msalInstance = new PublicClientApplication(msalConfig);
root.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
/* Dynamicly includes the Newrelic */
if (env.NEWRELIC_ENABLED) {
  newrelic.init();
}
